const toEnumString = (enumObject, key) => {
  return typeof key === "string" ? key : enumObject[key];
};
const getEnumKeys = (enumObject) => {
  return Object.keys(enumObject).filter((key) => isNaN(Number(key)));
};
const getEnumValues = (enumObject) => {
  return getEnumKeys(enumObject).map((key) => enumObject[key]);
};
const formatCamelCaseEnumValue = (value) => {
  return value?.split(/(?=[A-Z])/).map(upperFirst).map(upperAbbreviations).join(" ").replace(/([A-Z]+) (?=([A-Z]($|\s)))/g, "$1");
};
const formatSnakeCaseEnumValue = (value) => {
  return value?.split("_")?.map(upperFirst)?.map(upperAbbreviations)?.join(" ");
};
const upperFirst = (str) => {
  return str.slice(0, 1).toUpperCase() + str.slice(1, str.length).toLowerCase();
};
const upperAbbreviations = (str) => {
  const abbreviations = ["EDD", "KYC", "POA", "POP"];
  const abbreviationsRegexp = new RegExp(`\\b${abbreviations.join("|")}\\b`, "gi");
  return str.replaceAll(abbreviationsRegexp, (match) => match.toUpperCase());
};
export {
  formatCamelCaseEnumValue,
  formatSnakeCaseEnumValue,
  getEnumValues,
  toEnumString
};
//# sourceMappingURL=enum.js.map
